// components/SucursalesMercadoLibre/EditarCajaModal.js
import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  IconButton,
  Alert,
  InputAdornment,
} from '@mui/material';
import {
  Close,
  PointOfSale,
  Storefront,
} from '@mui/icons-material';

const EditarCajaModal = ({ open, caja, sucursales, onClose, onActualizar, onRecargar }) => {
  const [formData, setFormData] = useState({
    nombre: '',
  });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (caja) {
      setFormData({
        nombre: caja.name || '',
      });
    }
  }, [caja]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ 
      ...prev, 
      [name]: value 
    }));
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.nombre.trim()) {
      newErrors.nombre = 'El nombre es requerido';
    } else if (formData.nombre.length < 3) {
      newErrors.nombre = 'El nombre debe tener al menos 3 caracteres';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

const handleSubmit = async () => {
  if (!validateForm()) return;
  
  setSubmitting(true);
  try {
    // Datos para Mercado Pago (usa name)
    const updateDataMP = {
      name: formData.nombre.trim(),
    };
    
    // Datos para BD local - SOLO el nombre
    const updateDataLocal = {
      nombre: formData.nombre.trim(),
    };
    
    // console.log('📤 updateDataMP:', updateDataMP);
    // console.log('📤 updateDataLocal:', updateDataLocal);
    
    // Actualizar (pasar ambos objetos)
    await onActualizar(caja.id, updateDataMP, updateDataLocal);
    
    // Recargar datos
    if (onRecargar) {
      await onRecargar();
    }
    
    onClose();
  } catch (error) {
    console.error('Error al actualizar:', error);
  } finally {
    setSubmitting(false);
  }
};
  const getSucursalNombre = () => {
    const sucursal = sucursales.find(s => String(s.id) === String(caja?.sucursal_id));
    return sucursal?.name || sucursal?.nombre || 'Desconocida';
  };

  const getSucursalExternalId = () => {
    const sucursal = sucursales.find(s => String(s.id) === String(caja?.sucursal_id));
    return sucursal?.external_id || 'Desconocido';
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <PointOfSale sx={{ color: '#009ee3' }} />
          Editar Caja - {caja?.name}
        </Box>
        <IconButton onClick={onClose} size="small">
          <Close />
        </IconButton>
      </DialogTitle>
      
      <DialogContent>
        <Box sx={{ mt: 1 }}>
          <Alert severity="info" sx={{ mb: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Storefront fontSize="small" />
              <strong>Sucursal:</strong> {getSucursalNombre()}
              <br />
              <strong>ID Sucursal:</strong> {getSucursalExternalId()}
            </Box>
          </Alert>

          <TextField
            fullWidth
            size="small"
            label="Nombre de la caja *"
            name="nombre"
            value={formData.nombre}
            onChange={handleChange}
            error={!!errors.nombre}
            helperText={errors.nombre || "Ej: Caja Principal"}
            sx={{ mb: 2 }}
            InputProps={{
              startAdornment: <InputAdornment position="start"><PointOfSale /></InputAdornment>,
            }}
          />

          <TextField
            fullWidth
            size="small"
            label="ID Externo"
            value={caja?.external_id || ''}
            disabled
            helperText="No editable - Se genera automáticamente"
            sx={{ mb: 2 }}
          />
        </Box>
      </DialogContent>
      
      <DialogActions>
        <Button onClick={onClose} disabled={submitting}>
          Cancelar
        </Button>
        <Button 
          onClick={handleSubmit} 
          variant="contained" 
          disabled={submitting}
          sx={{ bgcolor: '#009ee3', '&:hover': { bgcolor: '#0080b3' } }}
        >
          {submitting ? 'Guardando...' : 'Guardar Cambios'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditarCajaModal;